// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

// Store
const tarea = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/tarea`,      
    state: {
          tarea:[]
        , tareabyelemento: []
        , tareashistorico: []
        , flujo:[]
        , tareas: []
        , gestionadas: []
        , procesos:[]
        , tiposproceso:[]
        , puedegestionar: false
        ,Flujos: []
    }
})
.get({
    action: "get_tareas",
    path:   function () {
        return "/activo/1" ;
    },      
    onSuccess: (state, payload) => {        
        state.tareas = payload.data;
    }
}).get({
    action: "get_tareasgestionadas",
    path:   function () {
        return `/seguimiento` ;
    },      
    onSuccess: (state, payload) => {        
        state.gestionadas = payload.data;
    }
}).get({
    action: "get_historicotareas",
    path: function (obj) {
        return `/historico/${obj.idtabla}/${obj.idelemento}`;
    },      
    onSuccess: (state, payload) => { 
        state.tareashistorico = payload.data;
    }
}).get({
    action: "get_procesos",
    path:   function () {
        return `/procesos` ;
    },      
    onSuccess: (state, payload) => {        
        state.procesos = payload.data;
    }
}).get({
    action: "get_tiposproceso",
    path:   function () {
        return `/tiposprocesousuario` ;
    },      
    onSuccess: (state, payload) => {        
        state.tiposproceso = payload.data;      
    }
}).get({
    action: "get_verificargestionformulario",
    path: function (obj) {
        return `/gestionaformulario/${obj.Tabla}/${obj.idelemento}/${obj.idusuario}/${obj.idrol}` ;
    },      
    onSuccess: (state, payload) => {    
        state.puedegestionar = payload.data;    
    },    
    onError: (error) => {
        store.dispatch("mensaje/set_error", error);
    } 
}).get({
    action: "get_flujosbyelemento",
    path: function (obj) {
        return `/flujosdeelementos/${obj.idproceso}/${obj.idelemento}/${obj.activo}` ;
    },      
    onSuccess: (state, payload) => {        
        state.Flujos = payload.data;      
    }
}).get({
    action: "get_tareasbyelemento",
    path: function (obj) {
        return `/tareasdeelementos/${obj.idproceso}/${obj.idelemento}/${obj.activo}` ;
    },      
    onSuccess: (state, payload) => {
        console.log("get_tareasbyelemento", payload.data)        
        state.tareabyelemento = payload.data;      
    }
}).get({
    action: "get_tareaactivabytipo",
    path: function (obj) {
        return `/tareaactivabytipo/${obj.idelemento}/${obj.idproceso}/${obj.idtipo}` ;
    },      
    onSuccess: (state, payload) => {        
        state.tareabyelemento = payload.data;      
    }
}).get({
    action: "get_tareasbyid",
    path: function (obj) {
        return `/gettareabyid/${obj.idtarea}` ;
    },      
    onSuccess: (state, payload) => {   
        state.flujo = []       
        state.tarea = payload.data;      
    }
}).get({
    action: "get_flujobyid",
    path: function (obj) {
        return `/flujosporid/${obj.idflujo}` ;
    },      
    onSuccess: (state, payload) => {    
        state.tarea = []
        state.flujo = payload.data;      
    }
}).get({
    action: "VerificarMotor",
    path: function (obj) {
        return `/verificarmotor/${obj.sendping}` ;
    },      
    onSuccess: (state, payload) => {        
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (error) => {
        store.dispatch("mensaje/set_error", error);
    }    
}).delete({
    action: "delete_task",
    path: function (obj) {
        return `EliminarTarea/${obj.idtarea}`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "PutTarea",
    path: function () {
        return `ActualizarTarea`
    },    
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        state.Aindicador.finalizar = false;
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "PutFlujo",
    path: function () {
        return `ActualizarFlujo`
    },    
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        state.Aindicador.finalizar = false;
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "CrearFlujo",
    path: function (obj) {
        return `crearflujo/${obj.idproceso}/${obj.idelemento}`
    },    
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();


tarea.getters = {  
    gtareas : state =>  {
        return state.tareas;
    },
    gtareasgestionadas : state =>  {
        return state.gestionadas;
    },
    gtareascerradas : state =>  {
        let g = null;
        if (state.tareashistorico.length > 0) {
            let g = state.tareashistorico.filter(p=>  p.idaccionNavigation !== undefined && p.idaccionNavigation !== null ) ;
            g = g.filter(p=> p.activo===false && p.idaccionNavigation.visible===true && p.idusuarioresponsable != null );
            return g;
        }
        return  g;
    },
    gprocesos : state =>  {
        return state.procesos;
    },
    gtiposprocesos : state =>  {
        return state.tiposproceso.filter(p=> p.visible === true);
    },
    gtienegestion : state =>  {
        return state.puedegestionar;
    },
    gflujosbyelemento : state =>  {
        return state.Flujos;
    },
    gtareasbyelemento : state =>  {
        return state.tareabyelemento;
    },
    gtareabyid : state =>  {
        return state.tarea;
    },
    gflujobyid : state =>  {
        return state.flujo;
    },
}

export default tarea;
